import React, { useEffect, useState } from "react";
import "../layout/Spinner.css";
import "./AthleteList.css";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import { Link } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import * as algoliasearch from "algoliasearch";
import AthleteSummary from "./AthleteDetailsSummary";
import { getFilter } from "../../utils/utils";

var filteredSearchBool = false;

const client = algoliasearch("KLMPV6497O", "e85f94bb57c008e5d960271ed61d0963");
const index = client.initIndex("athletes");

const AthleteDetailsList = (props) => {
  const [athletes, setAthletes] = useState([]);
  const [hitsX, setHitsX] = useState([]);
  const [searchFilters, setSearchFilters] = useState("profilePublic:true");
  useEffect(() => {
    if (props.athletes) {
      setAthletes(props.athletes);
    }
  }, [props.athletes]);
  const setData = async () => {
    const filteredSearch = props.filteredSearch;
    if (filteredSearch !== "") {
      filteredSearchBool = true;
      index
        .search(filteredSearch, {
          filters: searchFilters,
          hitsPerPage: props.perPage,
          page: props.activePage - 1,
        })
        .then((obj) => {
          if (obj.hits) {
            props.updatePage(obj.nbPages);
          }
          setHitsX(obj.hits);
        });
    } else {
      filteredSearchBool = false;
      if (props.athletes) {
        props.updatePage(props.athletes.length / props.perPage);
      }
      const athletesPaginated =
        props.athletes &&
        props.athletes.slice(
          (props.activePage - 1) * props.perPage,
          props.activePage * props.perPage
        );
      setHitsX(athletesPaginated);
    }
  };
  useEffect(() => {
    setData();
  }, [props.filteredSearch, props.perPage, props.activePage, props.athletes]);
  useEffect(() => {
    let filterString = `profilePublic:true AND committed:${props.showCommitted}`;
    if (props.filteredAcademics !== "None")
      filterString = filterString + ` AND ${props.filteredAcademics} != ${0}`;
    if (props.filteredGradClass > 0)
      filterString = filterString + ` AND class:${props.filteredGradClass}`;
    if (props.filteredSport)
      filterString = filterString + ` AND sport:${props.filteredSport}`;
    if (props.filteredPosition && props.filteredPosition !== "None")
      filterString =
        filterString + ` AND primaryPositionFilter:${props.filteredPosition}`;
    setSearchFilters(filterString);
  }, [
    props.filteredAcademics,
    props.filteredGradClass,
    props.filteredPosition,
    props.filteredSport,
    props.showCommitted,
  ]);
  if (!isLoaded(athletes)) {
    return (
      <div className="SpinnerBackground with-full">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else {
    return (
      <div className="AthlistListing">
        {hitsX &&
          hitsX.map((athlete) => {
            return (
              <Link
                to={"/athletes/" + athlete.customUrl}
                key={athlete.customUrl}
                target="_blank"
              >
                <AthleteSummary
                  athlete={athlete}
                  filteredSearch={filteredSearchBool}
                  key={athlete.customUrl}
                />
              </Link>
            );
          })}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    athletes: state.firestore.ordered.athletes,
    schools: state.firestore.data.schoolsList,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    return [getFilter(props)];
  })
)(AthleteDetailsList);
